import { useParams } from "react-router-dom";
import { useInspectionDetailsByRefQuery } from "../../../../__generated__/types-and-hooks";
import { Box, Card, CardContent, Typography } from "@mui/joy";
import Chat from "../../../dash/messages/Chat";
import { useTranslation } from "../../../../i18n";

export default function InspectionChat() {
  const { ref: uniqueId } = useParams();
  const t = useTranslation();

  const inspectionQuery = useInspectionDetailsByRefQuery({
    variables: { uniqueId: uniqueId! },
  });

  const inspection = inspectionQuery.data?.inspection_by_unique_id;
  if (!inspection) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      sx={{
        flex: 1, // this fills the remaining vertical space
        m: 2,
      }}
    >
      <Card
        sx={{
          backgroundColor: "hsl(0deg 0% 31.06% / 35%);",
          height: "100%",
          padding: 0,
        }}
      >
        <Typography sx={{ pt: 1, pl: 2 }} level="title-lg">
          {t("Direct Messages")}
        </Typography>
        <CardContent
          sx={{
            margin: "2px",
            borderRadius: 6,
            border: "1px solid black",
            height: "100%",
            gap: 0,
          }}
        >
          <Box
            gap={0.5}
            sx={{
              borderRadius: 6,
              flex: 1,
              width: "100%",
              mx: "auto",
            }}
          >
            {uniqueId && (
              <Chat entityId={uniqueId!} entityType={"inspection"} />
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
